import { useAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { CanvasObjectMeta } from '../../../context/SlideEditorContext';
import { useSlideEditorContext } from '../../../context/SlideEditorContext';
import { editorSelectionAtom } from '../../../store/atoms/editorSelectionAtom';
import { LayerItem } from '../../molecules/LayerItem';

export function LayersTab() {
  const { t } = useTranslation('slideEditor');
  const ctx = useSlideEditorContext();
  const [selection] = useAtom(editorSelectionAtom);
  const [objects, setObjects] = useState<CanvasObjectMeta[]>([]);

  const refresh = useCallback(() => {
    setObjects([...ctx.getObjects()].reverse());
  }, [ctx]);

  // Refresh on mount and whenever selection changes (indicates canvas changed)
  useEffect(() => {
    refresh();
  }, [refresh]);

  if (objects.length === 0) {
    return (
      <div className="flex items-center justify-center h-[5rem] px-mini">
        <span className="ts-caption-xxs text-ctx-content-placeholder">{t('layers.empty')}</span>
      </div>
    );
  }

  return (
    <div className="p-nano">
      {objects.map(obj => (
        <LayerItem
          key={obj.objectId || obj.label}
          objectId={obj.objectId}
          label={obj.label}
          type={obj.type}
          isSelected={selection?.objectId === obj.objectId}
          onClick={() => ctx.selectObject(obj.objectId)}
        />
      ))}
    </div>
  );
}
